import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="relative bg-black text-white pt-20 pb-10 border-t border-[#C9A55A]/10 overflow-hidden">
      {/* Premium Black Marble Background */}
      <div className="absolute inset-0 opacity-60">
        <img 
          src="https://customer-assets.emergentagent.com/job_consulting-synergy/artifacts/8d8vs3ta_396308DE-A733-4B81-9E45-26C3F8481D83.png"
          alt="Premium Marble Background"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-16">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_5b524126-89be-4764-a205-2c1c307aea3d/artifacts/mrnwuluu_5A3E72A5-2D0F-47D1-824C-1DD9B0FD96BF.png" 
              alt="Syndicate Consultants Inc" 
              className="h-32 sm:h-40 md:h-48 w-auto mb-8"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Excellence in strategic consulting and international procurement
            </p>
            <div className="flex space-x-5">
              <a href="#" className="text-gray-400 hover:text-[#C9A55A] smooth-transition">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A55A] smooth-transition">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A55A] smooth-transition">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-[#C9A55A] font-semibold mb-6 tracking-wide">Services</h3>
            <ul className="space-y-4">
              <li><Link to="/government-solutions" className="text-gray-400 hover:text-white smooth-transition text-sm">Government & Cybersecurity</Link></li>
              <li><Link to="/luxury-fashion" className="text-gray-400 hover:text-white smooth-transition text-sm">Luxury Fashion Procurement</Link></li>
              <li><Link to="/automotive" className="text-gray-400 hover:text-white smooth-transition text-sm">Automotive Brokerage</Link></li>
              <li><Link to="/real-estate-solutions" className="text-gray-400 hover:text-white smooth-transition text-sm">Real Estate Advisory</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white smooth-transition text-sm">All Services</Link></li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-[#C9A55A] font-semibold mb-6 tracking-wide">Industries</h3>
            <ul className="space-y-4">
              <li><Link to="/industries" className="text-gray-400 hover:text-white smooth-transition text-sm">Government & Defence</Link></li>
              <li><Link to="/industries" className="text-gray-400 hover:text-white smooth-transition text-sm">Luxury Fashion</Link></li>
              <li><Link to="/industries" className="text-gray-400 hover:text-white smooth-transition text-sm">Technology & Cybersecurity</Link></li>
              <li><Link to="/industries" className="text-gray-400 hover:text-white smooth-transition text-sm">Real Estate Development</Link></li>
              <li><Link to="/industries" className="text-gray-400 hover:text-white smooth-transition text-sm">Automotive</Link></li>
              <li><Link to="/industries" className="text-gray-400 hover:text-white smooth-transition text-sm">Healthcare & Medical</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-[#C9A55A] font-semibold mb-6 tracking-wide">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-sm text-gray-400">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-[#C9A55A]" />
                <span className="leading-relaxed">{companyInfo.address}</span>
              </li>
              <li className="text-sm text-gray-400">
                <Link to="/contact" className="hover:text-[#C9A55A] smooth-transition">
                  Get in Touch →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800/50 pt-10 mt-10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Syndicate Consultants Inc. All rights reserved.
            </p>
            <div className="flex space-x-8">
              <Link to="/privacy" className="text-gray-500 hover:text-[#C9A55A] text-sm smooth-transition">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-500 hover:text-[#C9A55A] text-sm smooth-transition">Terms of Service</Link>
              <Link to="/cookies" className="text-gray-500 hover:text-[#C9A55A] text-sm smooth-transition">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;